import { DeleteForever, OpenInNew, Repeat } from '@mui/icons-material'
import { Alert, AlertTitle, Link, Stack, Typography } from '@mui/material'
import { useTexts } from '../../useTexts'
import { RangePicker } from '../RangePicker'

export function EditPlanningRange() {
  const texts = useTexts()

  // Define the tidal skyBlue/800 color
  const tidalSkyBlue800 = '#22548C'

  return (
    <Stack direction="column" height="100%" marginTop={4}>
      <RangePicker />

      <Alert severity="info">
        <AlertTitle color={tidalSkyBlue800}>{texts.alertTitle}</AlertTitle>

        <Typography variant="body2" color={tidalSkyBlue800} marginBottom={2}>
          {texts.alertDescription}
        </Typography>

        <Stack spacing={2} marginTop={4}>
          <Stack direction="row" spacing={2} alignItems="center">
            <DeleteForever color="info" />
            <Typography variant="body1" color={tidalSkyBlue800} fontSize={14}>
              {texts.alertContentOne}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={2} alignItems="center">
            <Repeat color="info" />
            <Typography variant="body1" color={tidalSkyBlue800} fontSize={14}>
              {texts.alertContentTwo}
            </Typography>
          </Stack>
        </Stack>
      </Alert>

      <Stack direction="row" marginTop={4} marginBottom={4} alignItems="center">
        <Link
          href="https://workwave.my.site.com/routemanager/s/article/Territory-Settings"
          underline="none"
          rel="noopener noreferrer"
          target="_blank"
          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
        >
          <Typography variant="body2">{texts.learnMore}</Typography>
          <OpenInNew sx={{ fontSize: 16 }} />
        </Link>
      </Stack>
    </Stack>
  )
}
